'use strict';

var Promise = require('js/vendor/promise');
var $ = require('jquery');


var Request = Promise.extend();

/**
 * Construct an ajax options object from constructor params
 * @static
 */
Request.constructOptions = function(url, options) {
  // Defaults - Allow just passing options
  options = options || {};
  if (typeof url === 'string') {
    options.url = url;
  } else {
    options = url || options;
  }

  return options;
};

/**
 * Initialize our request with given options
 * - For now this is just a small wrapper around jquery.ajax
 * - Overrides any user success/error callbacks user provides
 */
Request.prototype.initialize = function(url, options) {
  Promise.prototype.initialize.call(this); // Initialize promise on request object

  // Defaults - Allow just passing options
  options = Request.constructOptions(url, options);

  // Force the prescence of a url
  if (!options.url) {
    throw new Error('Url is required for a Request object.');
  }

  // Store our options
  this.options = options;

  // Callbacks to resolve our promise
  options.success = function(data) {
    this.fulfil(data);
  }.bind(this);

  options.error = function(xhr, textStatus, errorThrown) {
    var error = new Error(errorThrown);

    this.break(error);

  }.bind(this);

  // Use jquery to construct our ajax call with given options
  this.xhr = $.ajax(options);
};

/**
 * Abort a request
 */
Request.prototype.abort = function() {
  this.xhr.abort();
};

/**
 * Helper factory method for GET type requests
 * @return {Request}
 */
Request.get = function(url, options) {
  // Defaults - Allow just passing options
  options = Request.constructOptions(url, options);
  options.type = 'GET'; // Force type

  return new Request(options);
};

/**
 * Helper factory method for POST type requests
 * @return {Request}
 */
Request.post = function(url, options) {
  // Defaults - Allow just passing options
  options = Request.constructOptions(url, options);
  options.type = 'POST'; // Force type

  return new Request(options);
};

/**
 * Helper factory method for PUT type requests
 * @return {Request}
 */
Request.put = function(url, options) {
  // Defaults - Allow just passing options
  options = Request.constructOptions(url, options);
  options.type = 'PUT'; // Force type

  return new Request(options);
};

/**
 * Helper factory method for DELETE type requests
 * @return {Request}
 */
Request.delete = function(url, options) {
  // Defaults - Allow just passing options
  options = Request.constructOptions(url, options);
  options.type = 'DELETE'; // Force type

  return new Request(options);
};

module.exports = Request;



// WEBPACK FOOTER //
// ./app/assets/js/lib/request.js